import React from "react";

const withLoadData = (WrapperComponent) => {
  const WithLoadData = (props) => {


    if (!props.isOpen) {
      return null;
    }

    return <WrapperComponent {...props}/>;
  };

  return WithLoadData;
};

export default withLoadData;
